import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import Auth from '@/helpers/auth'

Vue.use(Router)

const ensureRegisterData = (to, from, next) => {
  if (store.getters['register/email'].length === 0) {
    return next({ name: 'register-profile' })
  } else {
    return next()
  }
}

const adminMeta = {
  requiresAuth: true,
  authType: 'admin',
  transitionName: 'fade'
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/register',
      component: () => import('@/views/layouts/RegisterLayout.vue'),
      children: [
        {
          path: '/',
          name: 'register-profile',
          component: () => import('@/views/register/Profile.vue'),
          meta: { transitionName: 'fade' }
        },
        {
          path: '/register/divisions',
          name: 'register-divisions',
          component: () => import('@/views/register/Divisions.vue'),
          beforeEnter: (to, from, next) => { ensureRegisterData(to, from, next) },
          meta: { transitionName: 'slide' }
        },
        {
          path: '/register/confirmation',
          name: 'register-confirmation',
          component: () => import('@/views/register/Confirmation.vue'),
          beforeEnter: (to, from, next) => { ensureRegisterData(to, from, next) },
          meta: { transitionName: 'slide' }
        },
        {
          path: '/register/complete',
          name: 'register-complete',
          beforeEnter: (to, from, next) => { ensureRegisterData(to, from, next) },
          component: () => import('@/views/register/Complete.vue')
        }
      ]
    },
    {
      path: '/dashboard',
      component: () => import('@/views/layouts/ParticipantLayout.vue'),
      meta: {
        requiresAuth: true,
        authType: 'participant'
      },
      children: [
        {
          path: '/',
          name: 'participant-dashboard',
          component: () => import('@/views/participant/Dashboard.vue')
        },
        {
          path: '/division/:divisionId',
          name: 'participant-division',
          component: () => import('@/views/participant/Division.vue')
        }
      ]
    },
    {
      path: '/admin',
      component: () => import('@/views/layouts/LoggedLayout.vue'),
      meta: adminMeta,
      children: [
        {
          path: '/',
          name: 'admin-dashboard',
          component: () => import('@/views/admin/Dashboard.vue'),
          meta: adminMeta
        },
        {
          path: '/users',
          name: 'admin-users',
          component: () => import('@/views/admin/Users.vue'),
          meta: adminMeta
        },
        {
          path: '/events',
          name: 'admin-events',
          component: () => import('@/views/admin/Events.vue'),
          meta: adminMeta
        },
        {
          path: '/event/:id',
          name: 'admin-event',
          component: () => import('@/views/admin/SingleEvent.vue'),
          meta: adminMeta
        },
        {
          path: '/divisions',
          name: 'admin-divisions',
          component: () => import('@/views/admin/Divisions.vue'),
          meta: adminMeta
        },
        {
          path: '/submissions',
          name: 'admin-submissions',
          component: () => import('@/views/admin/Submissions.vue'),
          meta: adminMeta
        },
        {
          path: '/history',
          name: 'admin-history',
          component: () => import('@/views/admin/History.vue'),
          meta: adminMeta
        }
      ]
    },
    {
      path: '/submissions',
      component: () => import('@/views/layouts/JudgeLayout.vue'),
      meta: {
        requiresAuth: true,
        authType: 'judge'
      },
      children: [
        {
          path: '/',
          name: 'judge-dashboard',
          component: () => import('@/views/judge/Dashboard.vue')
        }
      ]
    },
    {
      path: '/profile',
      component: () => import('@/views/layouts/LoggedLayout.vue'),
      children: [
        {
          path: '/',
          name: 'profile',
          component: () => import('@/views/profile/Profile.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/Login.vue')
    },
    {
      path: '/recover-password',
      name: 'recover-password',
      component: () => import('@/views/auth/RecoverPassword.vue')
    },
    {
      path: '/reset-password/:recoveryId',
      name: 'reset-password',
      component: () => import('@/views/auth/ResetPassword.vue')
    },
    //  Invite for judges
    {
      path: '/invite/:inviteId',
      name: 'invite-signup',
      component: () => import('@/views/invite/Signup.vue')
    },
    //  Deactivated account
    {
      path: '/deactivated',
      name: 'deactivated',
      component: () => import('@/views/auth/Deactivated.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.requiresAuth) && to.matched.some(m => m.meta.authType)) {
    const token = Auth.getToken()
    const user = Auth.getUser()

    if (token === null || user === null) {
      next({ name: 'login' })
    } else {
      if (user.isActive || user.role === 'admin') {
        //  Redirect user to respective dashboard depending of role
        if (
          (to.meta.authType === 'admin' && user.role !== 'admin') ||
          (to.meta.authType === 'participant' && user.role !== 'participant') ||
          (to.meta.authType === 'judge' && user.role !== 'judge')
        ) {
          next({ name: `${user.role}-dashboard` })
        } else {
          next()
        }
      } else {
        console.log('YO')
        next({ name: `deactivated` })
      }
    }
  } else {
    next()
  }
})

export default router
